import { isCometBrowser } from '#pplx/frontend/comet/client/utils.js';
import { useQuery } from '@tanstack/react-query';
export const PERPLEXITY_EXTENSION_ID = 'pninphncmkphpjgfffammoenglghcjii';
const PING_TIMEOUT_MS = 1_500;
const PING_STALE_MS = 30_000;
function getExternalRuntime() {
    if (typeof chrome === 'undefined')
        return undefined;
    return typeof chrome.runtime?.sendMessage === 'function' ? chrome.runtime : undefined;
}
function sendToPerplexityExtension(message, timeoutMs) {
    const runtime = getExternalRuntime();
    if (!runtime)
        return Promise.resolve({ ok: false, error: 'extension_unreachable' });
    return new Promise((resolve) => {
        const timer = timeoutMs === undefined
            ? undefined
            : setTimeout(() => resolve({ ok: false, error: 'timeout' }), timeoutMs);
        const finish = (response) => {
            clearTimeout(timer);
            resolve(response);
        };
        try {
            runtime.sendMessage(PERPLEXITY_EXTENSION_ID, message, (response) => {
                const lastError = runtime.lastError;
                if (lastError) {
                    finish({ ok: false, error: lastError.message ?? 'extension_unreachable' });
                    return;
                }
                finish(response ?? { ok: false, error: 'no_response' });
            });
        }
        catch (error) {
            finish({ ok: false, error: error instanceof Error ? error.message : String(error) });
        }
    });
}
export function pingPerplexityExtension() {
    return sendToPerplexityExtension({ type: 'PING' }, PING_TIMEOUT_MS);
}
export function connectAsiViaPerplexityExtension(payload) {
    return sendToPerplexityExtension({ type: 'CONNECT_ASI', payload });
}
export function usePerplexityExtensionAvailable(enabled) {
    const { data } = useQuery({
        queryKey: ['perplexity-extension-ping'],
        queryFn: pingPerplexityExtension,
        enabled: enabled && !isCometBrowser() && getExternalRuntime() !== undefined,
        staleTime: PING_STALE_MS,
        refetchOnWindowFocus: true,
        retry: false,
    });
    return enabled && data?.ok === true;
}
//# sourceMappingURL=perplexityExtension.js.map